<template>
    <div class="edit-profile">
        <div class="edits">
            <div class="heading2-section">
                Forgot Your Password?
            </div>
        <form @submit.prevent="sendResetLink">
         <div class="mb-3">
            <label class="form-label">We need to send you a password reset link. If you do not recieve a link, simply come back to the page and click to resend. Please enter your account's Email Address.</label>
            <input type="text" v-model="user.email" class="form-control">
        </div>
       
         <div class="form-buttons mb-3">

                <button type="submit" class="btn btn-default primary-btn primary-btn-disabled" v-if="loading" disabled>Sending Link...</button>
                <button type="submit" class="btn btn-default primary-btn" v-else>Send Password Reset Link</button>
            </div>
             <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors -->  
        </form>
        <LoadingIndicator v-if="loading"/>
        </div>
    </div>
    <ConfirmationMessageModal :title="modal.caption" :body="modal.message" :button-label="modalButtonLabel" :close-modal="() => closeModal()"/>
</template>
<script>
import { sendPasswordResetLink } from '@/services/authService';
import Modal from 'bootstrap/js/dist/modal';
import ConfirmationMessageModal from '@/components/modals/ConfirmationMessageModal.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
export default {
    components:{
        LoadingIndicator,
        ConfirmationMessageModal
    },
    data(){
        return{
             url: process.env.VUE_APP_API_URL,
            user:{
                    email:"",
                },
             modal:{
                caption:"",
                message:""
            },
            confirmModal: null,
            errors:[],
            loading:false,
            hasErrors:false,
            modalButtonLabel:'Close'
        }
    },
    mounted(){
        this.confirmModal = new Modal(document.getElementById('confirmMessageModal'))
    },
    methods:{
     async sendResetLink(){
        try{
            this.resetOnNewSubmit();
            var data = await sendPasswordResetLink(this.user);
            this.loading = false;
            if(data.success){
                this.modal.caption = data.caption;
                this.modal.message = data.message;
                this.showModal();
        }else{
            if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                });
                this.hasErrors = true;
                return;
            }
             throw new Error(data.message, {cause: data.caption})
        }
        }catch(e){
            this.loading = false;
            this.modal.caption = e.cause || "Error";
            this.modal.message = e.message || "Something went wrong. Please try later";
            this.modalButtonLabel = 'Close'
            this.showModal();
        }     
    },
    resetOnNewSubmit(){
            this.loading = true;
            this.hasErrors = false;
            this.errors = [];
            this.modalButtonLabel = 'Close'
    },
     closeModal(){
      this.confirmModal.hide();
    },
    showModal(){
        this.confirmModal.show();
    }
   }

}
</script>
<style scoped>

.edit-profile{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin:4.5rem 0rem;
}

.edits{
    grid-column:2/3;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
}

.edit-profile{ 
    margin:2rem 0rem;
}
}
</style>